@if (isUpdating$ | async) {
<cx-spinner class="overlay"></cx-spinner>
}
<div class="login-page">
  <div class="login-title">{{'common.login_title'| cxTranslate}}</div>
  <div class="login-container">
    <div class="login-desc">{{'common.login_description'| cxTranslate}}</div>
    <div class="login-form-block">
      <form (ngSubmit)="onSubmit()" [formGroup]="form" [attr.method]="method" [attr.action]="action" #loginForm>
        <label>
          <span class="label-content">{{
            'common.login_email' | cxTranslate
            }}</span>
          <input aria-required="true" type="email" class="form-control" formControlName="userId" placeholder=""
            name="username" autocomplete="off" />

        </label>

        <label>
          <span class="label-content">{{
            'common.login_password' | cxTranslate
            }}</span>
          <input aria-required="true" type="password" class="form-control" placeholder="" formControlName="password"
            [attr.aria-label]="'loginForm.password.placeholder' | cxTranslate" cxPasswordVisibilitySwitch
            name="password" />

        </label>
        <ng-container *cxFeature="'authorizationCodeFlowByDefault'">
          @if (csrf) {
          <input formControlName="csrf" type="hidden" [name]="csrf.parameterName" />
          }
        </ng-container>
        <div class="row mt-3">
          <div class="col-xs-12 col-sm-12 col-md-6 text-align-end pt-2 pr-0">
            <div class="remember-me-login-box">
              <div class="checkBox">
                <input name="remember-me" type="checkbox" (change)="rememberMe($event)" [disabled]="!FunctionalCookies">
                <label for="remember-me-check">{{'common.remember_me' | cxTranslate}}</label>
              </div>
            </div>
          </div>
          @if (!emailSent) {
          <div class="col-xs-12 col-sm-12 col-md-6 content-Align-End">
            <mat-dialog-actions>
              <span (click)="openForgotPwd()" class="btn-link">
                {{ 'common.login_link_forgottenPwd' | cxTranslate }}
              </span>
            </mat-dialog-actions>
          </div>
          }
        </div>
        @if (emailSent) {
        <div class="pwd-reset-email-sent-title">
          {{'common.account_confirmation_email_sent' | cxTranslate}}
        </div>
        <div class="pwd-reset-email-sent-desc">
          {{'common.account_confirmation_forgotten_password_link_sent' | cxTranslate}}
        </div>
        }

        @if (!this.FunctionalCookies) {
        <p class="cookie-text">{{'common.text_rememberMe_cookie' | cxTranslate}} <a
            [routerLink]="'/cookies'">{{'common.here' | cxTranslate}}</a></p>
        }
        <button type="submit" class="btn btn-block btn-primary login-text-transform" [disabled]="form.invalid">
          {{ 'common.login_login' | cxTranslate }}
          <img src="/icons/link-dark-grey.svg" alt="" class="icon-right">
        </button>
        @if (baseSite == 'NA') {
        <div class="login-para">
          {{'common.loginpara' | cxTranslate}}
        </div>
        } @else {
        <div class="loginpara-notNA">
          <p>{{'common.loginParaNotNa' | cxTranslate}}</p>
          {{'common.loginContent'|cxTranslate}}
        </div>
        }
        <div class="new-user">{{'common.login_new_user' | cxTranslate}}</div>
      </form>
      <button type="submit" class="btn btn-block btn-primary login-text-transform" (click)="navigateToRegister()">
        {{'common.guest_register_submit' | cxTranslate}}<img src="/icons/link-dark-grey.svg" alt=""
          class="icon-right ml-2">
      </button>
    </div>
  </div>
</div>